import { v5 as uuidv5 } from 'uuid';

const cobrainerCustomNamespace = '57aa446c-7b4c-4059-a790-fc76f511676a';

export const createUuidFromString = (value: string): string => {
    return uuidv5(value, cobrainerCustomNamespace);
};
